import { MenuItemMetadata, MenuMetadataForChannel, MetadataTag, TagType } from '@/models';

export function findMetadataForMenuItem(
  itemId: string,
  metadata: MenuMetadataForChannel,
): MenuItemMetadata | undefined {
  return metadata.items[itemId];
}

export function getVariantsItemSectionTitle(metadata: MenuMetadataForChannel | null): string {
  const section = metadata && metadata.itemSections['Filling'];
  return section ? section.alias : '';
}

export function isMenuItemRewardsExclusive(tags: MetadataTag[]): boolean {
  return tags?.find(tag => tag.type == TagType.Rewards)?.type ? true : false;
}

export function getRewardsExclusiveTagText(tags: MetadataTag[]): string {
  return tags?.find(tag => tag.type == TagType.Rewards)?.value || '';
}